// extracted by mini-css-extract-plugin
export default {"bodyImage":"styles_bodyImage__ScdIU","bodyImageComplete":"styles_bodyImageComplete__kSpK0","bodyImageNoResults":"styles_bodyImageNoResults__KthCi"};